import { overrideEvent } from '@exadel/esl/modules/esl-utils/dom';
export class UIPChangeEvent extends Event {
    constructor(type, target, changes) {
        super(type, { bubbles: false, cancelable: false });
        this.changes = changes;
        overrideEvent(this, 'target', target);
    }
    get model() {
        return this.target.model;
    }
    get force() {
        return this.changes.some((change) => change.force);
    }
    get jsChanges() {
        return this.changes.filter((change) => change.type === 'js');
    }
    get htmlChanges() {
        return this.changes.filter((change) => change.type === 'html');
    }
    isOnlyModifier(modifier) {
        return this.changes.every((change) => change.modifier === modifier);
    }
}
